import { browserHistory } from 'react-router';
import { appConstants, accountConstants, routes } from '../constants';
import store from '../store';
import { AuthActions } from '../actions';

const { loginStates } = accountConstants;

const USER_LOCALSTORAGE_KEY = appConstants.CLIENTID + '-user';

export default class AuthDelegate {
    static get authStates() {
        return {
            AUTHORIZED: true,
            UNAUTHORIZED: false,
            DEFERRED: 'DEFERRED'
        }
    }

    static getSavedUser() {
        let user = localStorage.getItem(USER_LOCALSTORAGE_KEY);

        if (!user) {
            return false;
        } else {
            user = JSON.parse(user);
        }

        user.loginState = loginStates.UNVALIDATED;

        return user;
    }

    static userIsLoggedIn(isLoggedIn = true) {
        return user => {
            if (user.loginState === loginStates.UNVALIDATED) {
                return 'DEFERRED';
            }
            if (isLoggedIn) {
                return user.loginState === loginStates.LOGGED_IN;
            } else {
                return user.loginState !== loginStates.LOGGED_IN;
            }
        }
    }

    static userHasLoginState(state = loginStates.LOGGED_IN) {
        return user => {
            return user.loginState === state;
        }
    }

    static userHasRole(role) {

        let roles = role;
        if (!Array.isArray(role)) {
            roles = [role];
        }

        return user => {
            let isLoggedIn = AuthDelegate.userIsLoggedIn()(user);
            if (isLoggedIn !== true) {
                return isLoggedIn;
            }

            return roles.indexOf(user.roles) > -1;
        }
    }

    static userHasApprovalState(state) {
        let states = state;
        if (!Array.isArray(state)) {
            states = [state];
        }

        return user => {
            let isLoggedIn = AuthDelegate.userIsLoggedIn()(user);
            if (isLoggedIn !== true) {
                return isLoggedIn;
            }

            return states.indexOf(user.approvalStatus) > -1;
        }
    }

    static requireLogin(user) {
        switch (user.loginState) {
            case loginStates.UNVALIDATED:
                return false;
            case loginStates.LOGGED_IN:
                return true;
            case loginStates.LOGGED_OUT:
                browserHistory.push(routes.LOGIN);
                return false;
            default:
                browserHistory.push(routes.LOGIN);
                return false;
        }
    }

    static cancelRefreshToken() {
        try {
            window.clearTimeout(window.refreshTokenTimeout);
        } catch (error) {
            //ignored
        }
    }

    static scheduleRefreshToken(user) {
        const timeout = (Number(user.expires_in)  - 30) * 1000,
            callback = () => store.dispatch(AuthActions.refreshToken(user));

        window.refreshTokenTimeout = window.setTimeout(callback, timeout);
    }

    static saveUser(user) {
        localStorage.setItem(USER_LOCALSTORAGE_KEY, JSON.stringify(user));
        if (user && user.refresh_token) {
            AuthDelegate.scheduleRefreshToken(user);
        }
        else {
            AuthDelegate.cancelRefreshToken();
        }
    }

    static clearLocalStorage() {
        localStorage.clear();
    }
}



// WEBPACK FOOTER //
// ./web-app/utils/auth-delegate.js